import React from "react";
import { FaPlay } from "react-icons/fa";
import styled from "styled-components";
import PropTypes from "prop-types";

const Button = styled.a`
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  padding-top: 3px;
  padding-left: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  background-color: #dfe1e2;
  font-weight: bold;
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: 0.9;
  font-size: 20px;

  & > span {
    color: ${({ theme }) => theme.playBtnHighlights.color};
  }

  box-shadow: ${({ theme }) => `0px 0px 15px ${theme.playBtnHighlights.color}`};
  text-shadow: ${({ theme }) =>
    `0px 0px 15px ${theme.playBtnHighlights.color}`};

  ${({ theme }) =>
    theme.widgetWidth < 800 &&
    `
    width: 60px;
    height: 60px;
    font-size: 14px;
    padding-top: 7px;
    padding-left: 4px;   
  `}

  ${({ theme }) =>
    theme.widgetWidth < 400 &&
    `
    width: 40px;
    height: 40px;
    font-size: 13px;    
    padding-top: 4px;
    padding-left: 4px;
  `}
`;

export default function PlayButton({ onClick }) {
  return (
    <Button onClick={onClick} data-test="item-button">
      <span>
        <FaPlay />
      </span>
    </Button>
  );
}

PlayButton.propTypes = {
  onClick: PropTypes.func,
};
